import { Avatar, Grid, Typography, useTheme } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { OperationActivitySummary } from 'src/networkRequest/operationsService';
import { formatDateV2 } from '../../../../utils/formatDate';
import Utils from '../../../../utils/utils';
import ActivityChip from '@pages/Operations/components/ActivityChip';

type IncidentActivityProps = {
  activity: OperationActivitySummary
  activityPagePath: string
};
const IncidentActivity: React.FC<IncidentActivityProps> = (props) => {
  const { activity, activityPagePath } = props;
  const theme = useTheme();
  const authorName = Utils.fullName(
    activity.author.agency_official.first_name,
    activity.author.agency_official.last_name
  );
  const linkPath = activity.active ? activityPagePath : undefined;
  return (
    <Grid
      sx={{
        backgroundColor: theme.palette.grey[50],
        padding: '16px',
        marginBottom: '16px',
        borderRadius: '10px'
      }}
    >
      <Grid container sx={{
        justifyContent: 'space-between'
      }}>
        <Grid container>
          <Avatar
            sx={{ width: '24px', height: '24px', marginRight: '8px' }}
            alt={authorName}
            src={activity.author.agency_official.img_url || undefined}
          />
          <Grid container sx={{ flexDirection: 'column' }}>
            <Typography>{authorName}</Typography>
            <Typography sx={{ color: theme.palette.text.secondary }}>
              {formatDateV2(activity.performed_at)}
            </Typography>
          </Grid>
        </Grid>
        <ActivityChip
          label="Activity"
          icon={<DescriptionIcon />}
          active={false}
          linkPath={linkPath}
        />
      </Grid>
      <Typography
        sx={{
          mt: '16px',
          whiteSpace: 'pre-line'
        }}>{activity.description}</Typography>
    </Grid>
  );
};

export default IncidentActivity;
